import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "embed-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.94 3.27c.4.09.66.49.57.9l-3.56 16a.75.75 0 11-1.46-.33l3.56-16c.09-.4.49-.66.9-.57zM17.47 7.47c.3-.3.77-.3 1.06 0l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 11-1.06-1.06L20.94 12l-3.47-3.47a.75.75 0 010-1.06zM6.53 8.53a.75.75 0 00-1.06-1.06l-4 4c-.3.3-.3.77 0 1.06l4 4a.75.75 0 101.06-1.06L3.06 12l3.47-3.47z" }, null, -1)
  ])))
}
export default { render: render }